import type { Dictionary } from './types'

export const ru: Dictionary = {
  meta: {
    title: 'CRAFT TOWER DOO | Разработка ПО и IT-услуги в Черногории',
    description:
      'CRAFT TOWER DOO — компания в Черногории по разработке ПО и IT-услугам. Создаем сайты, приложения, автоматизацию, бизнес-системы и защищенную инфраструктуру для частных клиентов и бизнеса.',
  },
  nav: {
    services: 'Услуги',
    work: 'Работы',
    process: 'Процесс',
    about: 'О нас',
    contact: 'Контакты',
    menu: 'Меню',
    close: 'Закрыть',
    skip: 'Перейти к содержанию',
  },
  ui: {
    language: 'Язык',
    theme: 'Сменить светлую / темную тему',
    cyber: 'Кибер-режим',
    cyberHint: 'GO CYBER,\nTRY ME!',
    cyberBoot: '> ПОДКЛЮЧЕНИЕ… СЕТЬ АКТИВНА_',
    localTime: 'Бар',
    backToTop: 'Наверх',
    loading: 'Сборка',
  },
  hero: {
    badge: 'IT-студия в Черногории, город Бар',
    title: 'Надежный софт для',
    titleAccent: 'реальной работы',
    description:
      'В CRAFT TOWER мы проектируем и создаем сайты, бизнес-инструменты, автоматизацию и технические решения для частных клиентов и растущих компаний как в Черногории, так и за рубежом.',
    ctaPrimary: 'Начать проект',
    ctaSecondary: 'Наши работы',
    slogan: 'Пишем код. Строим будущее.',
  },
  proofs: [
    { label: 'Основана', value: '13.08.2021' },
    { label: 'Локация', value: 'Бар, Черногория' },
    { label: 'Языки', value: 'Английский, черногорский, русский' },
    { label: 'Фокус', value: 'Индивидуальная разработка ПО и IT-поддержка' },
  ],
  marquee: ['Сайты', 'Системы бронирования', 'Клиентские порталы', 'Админ-панели', 'ИИ-процессы', 'Автоматизация', 'Сети', 'IT-поддержка'],
  services: {
    label: 'Услуги',
    title: 'Сайты, внутренние инструменты, автоматизация и IT-поддержка.',
    description:
      'Будь то быстрый корпоративный сайт, система бронирования, клиентский портал, панель администратора или умная автоматизация внутренних процессов, CRAFT TOWER создает практичные решения для повседневной работы.',
    individualsButton: 'Для частных клиентов',
    businessButton: 'Для малого бизнеса',
    focus: 'В фокусе',
    individuals: [
      {
        eyebrow: 'Личные проекты',
        title: 'Сайты, дашборды и персональные инструменты',
        summary: 'Для фрилансеров, креаторов, семей и узких сообществ, которым нужно больше, чем просто типовой шаблон.',
        bullets: ['Личные сайты и портфолио', 'Персональные трекеры, панели управления и порталы', 'Формы, карты, боты и API-интеграции'],
        focus: ['Современные сайты-портфолио', 'Персональные настраиваемые дашборды', 'Трекеры и помощники для RPG и настольных игр'],
      },
      {
        eyebrow: 'Практическая поддержка',
        title: 'Настройка IT-инфраструктуры и повседневная техническая помощь',
        summary:
          'Для тех, кто хочет надежно настроить рабочую среду, повысить безопасность устройств и избавиться от технических проблем.',
        bullets: [
          'Настройка устройств и софта',
          'Резервное копирование, защита паролей и настройка домашней сети',
          'Практическая помощь с ИИ и инструментами автоматизации',
        ],
        focus: ['Только то, что действительно нужно для работы', 'Безопасность — главный приоритет', 'Ускорение и автоматизация вашей рутины'],
      },
    ],
    business: [
      {
        eyebrow: 'Системы для клиентов',
        title: 'Веб-сайты, системы бронирования и сбор лидов',
        summary: 'Для малого бизнеса, которому важно произвести отличное первое впечатление и упростить путь клиента.',
        bullets: [
          'Корпоративные сайты и лендинги',
          'Бронирование, заявки и процесс выставления предложений',
          'SEO-оптимизированная структура и настройка аналитики',
        ],
        focus: ['Современный дизайн с лучшими SEO-практиками', 'Эффективные и удобные дашборды', 'Анализ данных и повышение производительности'],
      },
      {
        eyebrow: 'Внутренние процессы',
        title: 'Бизнес-инструменты, автоматизация и инфраструктура',
        summary: 'Для команд, которым нужны удобные системы, чтобы сократить рутину и навести порядок в рабочих процессах.',
        bullets: [
          'Индивидуальные админ-панели и внутренние инструменты',
          'Внедрение ИИ и автоматизация процессов',
          'Настройка сетей, устройств и поддержка облачных решений',
        ],
        focus: ['Чистые настраиваемые интерфейсы', 'Максимально эффективные автоматизированные процессы', 'Надежная техническая поддержка'],
      },
    ],
  },
  work: {
    label: 'Работы',
    title: 'Избранные работы',
    description:
      'Скриншоты, промо-видео и истории продуктов, которые мы создаем. Здесь вы можете увидеть некоторые из наших проектов.',
    projects: 'Проекты',
    loadMore: 'Показать ещё',
    soon: 'Скоро: больше проектов в разработке',
    highlights: 'Что мы сделали',
    viewCase: 'Смотреть кейс',
    status: { concept: 'Концепт', 'in-progress': 'В работе', live: 'Запущен' },
    links: { live: 'Открыть сайт', case: 'Кейс', repo: 'Исходный код', store: 'Магазин приложений' },
    promo: 'Промо-видео',
    outcome: 'Результат',
    scope: 'Объем',
    stack: 'Стек',
    client: 'Клиент',
    year: 'Год',
    category: 'Категория',
    screens: 'Экраны',
    screensSoon: 'Скриншоты и промо-видео этого проекта скоро появятся.',
    prevScreen: 'Предыдущий скриншот',
    nextScreen: 'Следующий скриншот',
    prev: 'Предыдущий проект',
    next: 'Следующий проект',
    close: 'Закрыть',
  },
  process: {
    label: 'Процесс',
    title: 'Как идет работа над проектом',
    readout: 'Прогресс сборки',
    phases: ['Анализ', 'Дизайн', 'Разработка', 'Тестирование', 'Запуск'],
    steps: [
      'Вводный звонок и оценка проекта',
      'UI-концепция и техническая архитектура',
      'Поэтапная сборка функционала и интеграции',
      'Контроль качества, оптимизация и безопасность',
      'Релиз в продакшн и практическая поддержка',
    ],
  },
  about: {
    label: 'О нас',
    title: 'Наше видение',
    p1: 'Технологии не должны быть сложными. В CRAFT TOWER мы верим, что IT и программирование — это прежде всего инструменты, которые делают вашу жизнь и бизнес проще и стабильнее.',
    p2: 'Будь то разработка веб-приложения с нуля, внедрение ИИ в ваши рабочие процессы или создание безопасной и быстрой сети, мы обходимся без лишнего корпоративного жаргона. Мы создаем чистый код, обеспечиваем надежную поддержку и делаем продукты, которые действительно работают.',
    sign: 'Andrey D',
    role: 'Основатель',
    checklistTitle: 'Как мы выстраиваем сотрудничество',
    checklist: [
      'Четкое понимание задачи до старта разработки',
      'Прозрачное согласование концепции вместо работы наугад',
      'Прямое общение с человеком, который разрабатывает ваше решение',
    ],
    company: 'Компания',
    founded: 'Основана',
    address: 'Адрес',
    addressValue: 'Šušanj b.b., 85000 Бар, Черногория',
  },
  contact: {
    label: 'Контакты',
    titleLead: 'Создаем надежные, практичные и быстрые',
    titleAccent: 'решения.',
    description:
      'CRAFT TOWER находится в Баре, Черногория, и специализируется на разработке ПО и IT-поддержке, которые приносят реальную пользу людям и компаниям.',
    cta: 'Обсудить ваш проект',
    email: 'Email',
    phone: 'Телефон / Viber / WhatsApp',
    web: 'Сайт',
    address: 'Адрес',
    form: {
      title: 'Отправить',
      highlight: 'сообщение',
      subtitle: 'Есть идея проекта? Давайте обсудим.',
      name: 'Полное имя',
      email: 'Email адрес',
      message: 'Сообщение',
      namePlaceholder: 'Ваше имя',
      emailPlaceholder: 'you@example.com',
      messagePlaceholder: 'Расскажите о вашем проекте...',
      send: 'Отправить сообщение',
      sending: 'Отправка…',
      success: 'Сообщение отправлено! Я скоро свяжусь с вами.',
      error: 'Что-то пошло не так. Попробуйте еще раз.',
      invalid: 'Заполните все поля и укажите корректный email.',
    },
  },
  agent: {
    home: 'Привет! Нужен сайт, инструмент или автоматизация?',
    services: 'Выберите, для кого — покажу, что подойдет.',
    work: 'Наш первый настоящий кейс, MonteGigs, уже на первом месте. Скоро будут и другие!',
    process: 'Этаж за этажом — так мы строим.',
    about: 'Четкие задачи, честные черновики, прямой контакт.',
    contact: 'Расскажите о своей идее — мы с вами свяжемся.',
    sendMessage: 'Отправить сообщение',
    openChat: 'Живой Чат',
    onlineStatus: 'В сети',
    badgeText: 'CT-AGENT',
  },
  cookie: {
    badge: 'Приватность и безопасность',
    title: 'Мы заботимся о вашей безопасности и приватности',
    description:
      'Мы используем файлы cookie и локальное хранилище для безопасной работы сайта, сохранения языка и темы, а также сессий живого чата через Telegram. Никаких сторонних рекламных трекеров.',
    agentNote: 'Безопасно и защищено: все настройки сохраняются локально на вашем устройстве.',
    acceptAll: 'Принять все',
    essentialOnly: 'Только необходимые',
    managePreferences: 'Подробности и настройки',
    modalTitle: 'Настройки cookie и конфиденциальности',
    modalSubtitle: 'Прозрачная информация об использовании файлов cookie и локального хранилища в CRAFT TOWER DOO.',
    strictlyNecessary: 'Строго необходимые cookie',
    strictlyNecessaryDesc: 'Требуются для работы сайта, переключения языков, безопасности и темы. Не могут быть отключены.',
    liveChat: 'Живой чат поддержки',
    liveChatDesc: 'Анонимный токен сессии для общения с нашей командой в реальном времени через Telegram.',
    analytics: 'Производительность и телеметрия',
    analyticsDesc: 'Анонимные метрики для ускорения загрузки и стабильности сайта в Черногории и по всему миру.',
    alwaysActive: 'Всегда активны',
    dataController: 'Оператор данных: CRAFT TOWER DOO (г. Бар, Черногория) · info@craft-tower.com',
    savePreferences: 'Сохранить настройки',
    close: 'Закрыть',
    footerLink: 'Приватность и cookie',
  },
  chat: {
    title: 'Craft Tower Живой Чат',
    subtitle: 'Задайте любой вопрос онлайн',
    online: 'В сети',
    welcomeMsg: 'Здравствуйте! Чем мы можем помочь вам сегодня?',
    namePromptTitle: 'Добро пожаловать в чат',
    namePromptSubtitle: 'Пожалуйста, введите ваше имя для начала общения:',
    namePlaceholder: 'Введите ваше имя...',
    nameSubmit: 'Начать чат',
    chattingAs: 'Вы общаетесь как',
    edit: 'Изм.',
    placeholder: 'Введите сообщение...',
    send: 'Отправить',
    sending: 'Отправка…',
    adminTitle: 'Команда Craft Tower',
    aiAssistantTitle: 'CT-Agent ИИ (Gemma 4)',
    you: 'Вы',
    modeAi: 'ИИ-Ассистент',
    modeHuman: 'Живая связь',
    modeHumanNotice: 'Вы переключились на живую связь с командой. Оставьте сообщение, и наши инженеры ответят вам в Telegram в рабочие часы (10:00–16:00)!',
    roundBadge: 'Раунд',
    limitNotice: 'Дневной лимит консультации исчерпан (10/10 раундов). Наша команда получила запись диалога в Telegram и свяжется с вами в рабочее время (10:00–16:00).',
    sessionTerminatedNotice: 'Диалог завершен (вопросы вне компетенции студии). По проектам пишите на info@craft-tower.com.',
    unreadMsg: 'Новое сообщение от Craft Tower',
    offlineNotice: 'Чат временно недоступен. Вы можете отправить нам сообщение через форму или на info@craft-tower.com.',
    notificationsTooltip: 'Включить уведомления об ответах оператора',
    notificationsActive: 'Уведомления включены',
    soundMute: 'Выключить звук чата',
    soundUnmute: 'Включить звук чата',
    export: 'Экспорт стенограммы',
    downloadMd: 'Скачать Markdown (.md)',
    downloadPdf: 'Печать / Сохранить как PDF',
    emailSummary: 'Отправить на email',
    emailPromptTitle: 'Получить резюме консультации',
    emailPromptSubtitle: 'Укажите ваш email для получения копии стенограммы и сводки запроса:',
    emailPlaceholder: 'vash@email.com',
    emailSubmit: 'Отправить на email',
    emailSentSuccess: 'Стенограмма и сводка запроса отправлены на ваш email!',
    systemNotice: 'Системное уведомление',
    verificationNotice: 'Не удалось завершить проверку безопасности. Если вы используете блокировщик рекламы или расширения приватности, разрешите challenges.cloudflare.com или попробуйте снова.',
  },
  footer: {
    made: 'Спроектировано и разработано в Баре, Черногория.',
    rights: 'Все права защищены.',
    oldSite: 'Старый сайт',
  },
  cyber: {
    hero: {
      title: 'Цифровая эволюция',
      titleAccent: 'уже здесь.',
      description:
        'Добро пожаловать в новую эру технологий. Мы не просто пишем код — мы проектируем высокопроизводительные цифровые системы для новой эпохи.',
      slogan: 'Чистый код. Искусственный интеллект. Добро пожаловать в сеть.',
    },
    about: {
      p1: 'Технологии не должны вас тормозить. Нужно ли вам автоматизировать рутину с помощью ИИ, развернуть защищенную серверную сеть или запустить продвинутое веб-приложение — мы отключаем корпоративный шум.',
      p2: 'Мы выдаем чистый код, безопасные системы и прорывные решения, которые дают вам преимущество. Подключайтесь к сети, и давайте создадим нечто экстраординарное.',
    },
  },
}
